<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.checklist.pre_service_checks' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

    <div class="checklist-container">
        <div *ngFor="let checklistItem of checklist" [ngClass]="{'full-width' : !checklistItem.frontRearCheck && checklistItem.controlType !== 'CHECKBOX',
                        'half-width' : checklistItem.frontRearCheck && checklistItem.controlType !== 'CHECKBOX'}">
          <div *ngIf="!checklistItem.frontRearCheck">
            <div *ngIf="checklistItem.controlType === 'CHECKBOX'">
              <div class="checkbox" (click)="checklistItem.defaultValue = !checklistItem.defaultValue"
                   [ngStyle]="{backgroundColor: getColor(checklistItem.labelColour)}">
                <span class="checkbox-action">
                  <daz-icon *ngIf="checklistItem.defaultValue" [name]="'check'"
                            [size]="'20px'" [color]="checklistItem.labelColour"></daz-icon>
                </span>
                <div class="checkbox-name">
                  {{ checklistItem.description }}
                </div>
              </div>
            </div>
            <div *ngIf="checklistItem.controlType === 'TEXT'" class="checklist-item">
              <hub-input [label]="checklistItem.description" [labelColor]="checklistItem.labelColour"
                         [(ngModel)]="checklistItem.defaultValue"></hub-input>
            </div>
            <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'" class="checklist-item">
              <hub-text-area [label]="checklistItem.description" [labelColor]="checklistItem.labelColour"
                             [(ngModel)]="checklistItem.defaultValue" [rows]="3"></hub-text-area>
            </div>
            <div *ngIf="checklistItem.controlType === 'RADIO'" class="checklist-item checklist-item-radio">
              <div class="jobcard-label"
                   [ngStyle]="{color: checklistItem.labelColour ? checklistItem.labelColour : ''}">
                {{checklistItem.description}}
              </div>
              <div>
                <p-radioButton name="{{checklistItem.description}}" value="{{'general.yes' | translate}}"
                               label="{{('general.yes' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               labelStyleClass="p-radiobutton-label-override"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}" value="{{'general.no' | translate}}"
                               label="{{('general.no' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               labelStyleClass="p-radiobutton-label-override"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}"
                               value="{{'general.not_applicable' | translate}}" label="NA"
                               [(ngModel)]="checklistItem.defaultValue"
                               labelStyleClass="p-radiobutton-label-override"></p-radioButton>
              </div>
            </div>

            <div *ngIf="checklistItem.controlType === 'TRAFFICLIGHT'" class="checklist-item checklist-item-radio" style="width: 100%; ">
              <div class="jobcard-label" style="width: 50%"
                   [ngStyle]="{color: checklistItem.labelColour ? checklistItem.labelColour : ''}">
                {{checklistItem.description}}
              </div>
              <div class="radio-group">
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.yes' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="red-border"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.no' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="yellow-border"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}}_F"
                               value="{{'general.not_applicable' | translate}}"
                               [(ngModel)]="checklistItem.defaultValue"
                               styleClass="green-border"></p-radioButton>

                <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" maxlength="1500" style="max-width:163px;min-width:163px" />

              </div>
            </div>
          </div>
          <div *ngIf="checklistItem.frontRearCheck">
            <div *ngIf="checklistItem.controlType === 'CHECKBOX'" class="front-rear-checkbox">
              <div class="checkbox" (click)="checklistItem.frontValue = !checklistItem.frontValue"
                   [ngStyle]="{backgroundColor: getColor(checklistItem.labelColour)}">
                <span class="checkbox-action">
                  <daz-icon *ngIf="checklistItem.frontValue" [name]="'check'"
                            [size]="'20px'" [color]="checklistItem.labelColour"></daz-icon>
                </span>
                <div class="checkbox-name">
                  {{ checklistItem.description }} (F)
                </div>
              </div>
              <div class="checkbox" (click)="checklistItem.rearValue = !checklistItem.rearValue"
                   [ngStyle]="{backgroundColor: getColor(checklistItem.labelColour)}">
                <span class="checkbox-action">
                  <daz-icon *ngIf="checklistItem.rearValue" [name]="'check'"
                            [size]="'20px'" [color]="checklistItem.labelColour"></daz-icon>
                </span>
                <div class="checkbox-name">
                  {{ checklistItem.description }} (R)
                </div>
              </div>
            </div>
            <div *ngIf="checklistItem.controlType === 'TEXT'" class="checklist-item">
              <hub-input [label]="checklistItem.description + '(F)'" [labelColor]="checklistItem.labelColour"
                         [(ngModel)]="checklistItem.frontValue"></hub-input>
            </div>
            <div *ngIf="checklistItem.controlType === 'TEXT'" class="checklist-item">
              <hub-input [label]="checklistItem.description + '(R)'" [labelColor]="checklistItem.labelColour"
                         [(ngModel)]="checklistItem.rearValue"></hub-input>
            </div>
            <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'" class="checklist-item">
              <hub-text-area [label]="checklistItem.description + '(F)'" [labelColor]="checklistItem.labelColour"
                             [(ngModel)]="checklistItem.frontValue" [rows]="3"></hub-text-area>
            </div>
            <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'" class="checklist-item">
              <hub-text-area [label]="checklistItem.description + '(R)'" [labelColor]="checklistItem.labelColour"
                             [(ngModel)]="checklistItem.rearValue" [rows]="3"></hub-text-area>
            </div>
            <div *ngIf="checklistItem.controlType === 'RADIO'" class="checklist-item checklist-item-radio">
              <div class="jobcard-label"
                   [ngStyle]="{color: checklistItem.labelColour ? checklistItem.labelColour : ''}">
                {{checklistItem.description}} (F)
              </div>
              <div>
                <p-radioButton name="{{checklistItem.description}} F" value="{{'general.yes' | translate}}"
                               label="{{('general.yes' | translate).substring(0,1)}}"
                               [(ngModel)]="checklistItem.frontValue"
                               labelStyleClass="p-radiobutton-label-override"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}} F" value="{{'general.no' | translate}}"
                               label="{{('general.no' | translate).substring(0,1)}}" [(ngModel)]="checklistItem.frontValue"
                               labelStyleClass="p-radiobutton-label-override"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}} F"
                               value="{{'general.not_applicable' | translate}}" label="NA"
                               [(ngModel)]="checklistItem.frontValue"
                               labelStyleClass="p-radiobutton-label-override"></p-radioButton>
              </div>
            </div>
            <div *ngIf="checklistItem.controlType === 'RADIO'" class="checklist-item checklist-item-radio">
              <div class="jobcard-label"
                   [ngStyle]="{color: checklistItem.labelColour ? checklistItem.labelColour : ''}">
                {{checklistItem.description}} (R)
              </div>
              <div>
                <p-radioButton name="{{checklistItem.description}} R" value="{{'general.yes' | translate}}"
                               label="{{('general.yes' | translate).substring(0,1)}}" [(ngModel)]="checklistItem.rearValue"
                               labelStyleClass="p-radiobutton-label-override"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}} R" value="{{'general.no' | translate}}"
                               label="{{('general.no' | translate).substring(0,1)}}" [(ngModel)]="checklistItem.rearValue"
                               labelStyleClass="p-radiobutton-label-override"></p-radioButton>
                <p-radioButton name="{{checklistItem.description}} R"
                               value="{{'general.not_applicable' | translate}}" label="NA"
                               [(ngModel)]="checklistItem.rearValue"
                               labelStyleClass="p-radiobutton-label-override"></p-radioButton>
              </div>
            </div>

            <div *ngIf="checklistItem.controlType === 'TRAFFICLIGHT'" class="checklist-item checklist-item-radio" style="width: 100%; ">
              <div class="jobcard-label" style="width: 50%"
                   [ngStyle]="{color: checklistItem.labelColour ? checklistItem.labelColour : ''}">
                {{checklistItem.description}}
              </div>
              <div class="radio-group">

                <div style="min-width: max-content; display: flex; align-items: center; column-gap: 8px;">
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.yes' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="red-border"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.no' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="yellow-border"></p-radioButton>
                  <p-radioButton name="{{checklistItem.description}}_F"
                                 value="{{'general.not_applicable' | translate}}"
                                 [(ngModel)]="checklistItem.defaultValue"
                                 styleClass="green-border"></p-radioButton>
                </div>


                <span style="padding-top:2%">F</span>
                <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" maxlength="1500" style="width: 16% !important; margin:1%" />

                <span style="padding-top:2%">R</span>
                <input type="text" pInputText [(ngModel)]="checklistItem.rearValue" maxlength="1500" style="width: 16% !important; margin:1%" />
              </div>
            </div>
          </div>
        </div>
    </div>

</div>
<div class="modal-footer-container">
    <div class="button-container">
        <hub-button
            [text]="(hasCheckedItems() ? 'bikeshop.workshop.jobcard.checklist.uncheck_all_boxes' : 'bikeshop.workshop.jobcard.checklist.check_all_boxes') | translate"
            (buttonClick)="hasCheckedItems() ? uncheckAllBoxes() : checkAllBoxes()" [style]="'borderless-secondary'"
            [size]="'xl'"></hub-button>
        <hub-button [text]="'onboarding.button.done' | translate" (buttonClick)="done()" [style]="'secondary'"
            [size]="'xl'"></hub-button>
    </div>
    <div class="short-cut-container">
        <!-- <div>
            {{'bikeshop.workshop.jobcard.quote.to_navigate' | translate}}
        </div> -->
        <div>
            <span><daz-icon [name]="'enter'" [size]="'18px'"
                    [color]="'#6B728C'"></daz-icon></span>{{'bikeshop.workshop.jobcard.quote.to_save_and_close' |
            translate}}
        </div>
    </div>
</div>
